<template>
    <div class="cabinet-content-wrap">
        <div v-if="loading" class="pt-4 mt-3">Loading...</div>
        <div v-else>
            <header
                class="cabinet-header cabinet-header--large d-flex flex-column mt-24"
            >
                <a
                    href="javascript:void(0)"
                    class="dashboard__back-link"
                    @click="$router.go(-1)"
                ></a>
                <h1 class="h1 cabinet-title mt-24">
                    {{ retailer[0].company_name }}
                </h1>
                <button
                    class="cabinet-btn cabinet-btn--transparent2 cabinet-btn--small mt-10 dashboard-list__btn"
                    @click="openMessageModal(retailer[0])"
                >
                    Отправить сообщение
                </button>
                <div class="pr-3 pl-3 pb-1"></div>
            </header>
            <div
                class="v2-retailer v2-retailer-brand__nav flex flex-justify-sb"
            >
                <div
                    class="cabinet-product-detail-nav cabinet-product-detail-nav--suppliers-detail flex flex-justify-sb flex-align-center"
                >
                    <div
                        class="cabinet-product-detail-nav__link cabinet-product-detail-nav__link--unlink active"
                    >
                        Документы
                    </div>
                </div>
            </div>
            <div class="cabinet-settings cabinet-settings-documents">
                <div
                    class="cabinet-settings-documents__list cabinet-settings-documents__list--download"
                >
                    <a
                        v-for="doc in staticDocs"
                        :key="doc.id"
                        :href="`${doc.filename}`"
                        class="cabinet-settings-documents__item"
                        download
                        target="_blank"
                    >
                        <div
                            class="cabinet-settings-documents__item-title subtitle2 flex"
                        >
                            {{ doc.document_name }}
                        </div>
                    </a>
                    <div
                        v-if="contractDocs.length > 0"
                        class="cabinet-settings-documents__subtitle subtitle1"
                    >
                        Бланк(и) Договора(ов)
                    </div>
                    <a
                        v-for="doc in contractDocs"
                        :key="doc.id"
                        :href="`${doc.filename}`"
                        class="cabinet-settings-documents__item"
                        download
                        target="_blank"
                    >
                        <div
                            class="cabinet-settings-documents__item-title subtitle2 flex"
                        >
                            {{ doc.document_name }}
                        </div>
                    </a>
                </div>
            </div>

            <message-modal
                :is-open="isMessageModalOpen"
                :retailer="selectedRetailer"
                @closeModal="onCloseMessageModal"
                @onSend="onMessageSend"
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MessageModal from '@/components/Cabinet/Supplier/Dashboard/MessageModal'

export default {
    name: 'GlobalRetailersDocs',
    components: { MessageModal },
    data() {
        return {
            loading: true,
            isMessageModalOpen: false,
            selectedRetailer: {}
        }
    },
    computed: {
        ...mapState('supplierStatsRetailers', ['retailer']),
        ...mapState('supplierDocs', ['docs']),
        staticDocs() {
            return this.docs.filter(d => d.type !== 'contract')
        },
        contractDocs() {
            return this.docs.filter(d => d.type == 'contract')
        },
        APP_URL() {
            return process.env.VUE_APP_URL_APP
        }
    },
    async mounted() {
        await this.getRetailer(this.$route.params.id)
        await this.getDocs(this.$route.params.id)

        this.loading = false
    },
    methods: {
        ...mapActions('supplierStatsRetailers', ['getRetailer']),
        ...mapActions('supplierDocs', ['getDocs']),
        openMessageModal(retailer) {
            this.selectedRetailer = retailer
            this.isMessageModalOpen = true
        },
        onCloseMessageModal() {
            this.selectedRetailer = {}
            this.isMessageModalOpen = false
        },
        onMessageSend() {
            console.log('onMessageSend')
        }
    }
}
</script>
